import { FormActions } from "../../components/common/FormActions";
import { createViewAction, formatDate } from "../../utils/helpers";
import { URL_RECONCILIATIONS_REPORTS } from "../../utils/urls";

const url = URL_RECONCILIATIONS_REPORTS;

// REGISTER
export const useReconciliationsReports = () => {
  const tableColumns = () => [
    { id: "transaction_id", header: "Transaction ID", filter: {} },
    { id: "provider_ref_id", header: "Provider Ref Id", filter: {} },
    { id: "merchant_ref_id", header: "Merchant Ref Id", filter: {} },
    { id: "amount", header: "Amount", filter: {} },
    { id: "item_name", header: "Item Name", filter: {} },
    { id: "customer_number", header: "Customer Number", filter: {} },
    { id: "final_status", header: "Status", filter: {} },
    { id: "payment_date", header: "Payment Date", filter: {} },
    { id: "actions", header: "Actions" },
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        payment_date: formatDate(item?.payment_date),

        actions: (
          <FormActions
            actions={[createViewAction(url, item?.transaction_id)]}
          />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Reconciliations Report Details",
          fields: {
            transaction_id: item?.transaction_id,
            provider_ref_id: item?.provider_ref_id,
            merchant_ref_id: item?.merchant_ref_id,
            amount: item?.amount,
            item_name: item?.item_name,
            customer_number: item?.customer_number,
            status: item?.final_status,
            payment_date: formatDate(item?.payment_date),
          },
        },
      ],
    };
  };

  const tableTitle = "Reconciliations";

  return { tableData, tableColumns, tableTitle, viewData };
};
